import { networkService } from "services/networkService";
import {
  METHOD_VMWARE_SOLUTION_TYPE_LIST,
  METHOD_VMWARE_SOLUTION_TYPE_CREATE,
  METHOD_VMWARE_SOLUTION_TYPE_UPDATE,
  METHOD_VMWARE_SOLUTION_TYPE_DELETE,
  METHOD_VMWARE_SOLUTION_TYPE_DETAIL,
  METHOD_UCP_RELEASE_VERSION_LIST,
  METHOD_UCP_RELEASE_VERSION_CREATE,
  METHOD_UCP_RELEASE_VERSION_DELETE,
  METHOD_UCP_RELEASE_VERSION_DETAIL,
  METHOD_UCP_RELEASE_VERSION_UPDATE,
  METHOD_VMWARE_VCF_VERSION_LIST,
  METHOD_VMWARE_VCF_VERSION_DETAIL,
  METHOD_VMWARE_VCF_VERSION_CREATE,
  METHOD_VMWARE_VCF_VERSION_UPDATE,
  METHOD_VMWARE_VCF_VERSION_DELETE,
  METHOD_MANAGEMENT_SOFTWARE_VERSION_LIST,
  METHOD_MANAGEMENT_SOFTWARE_VERSION_DETAIL,
  METHOD_MANAGEMENT_SOFTWARE_VERSION_CREATE,
  METHOD_MANAGEMENT_SOFTWARE_VERSION_UPDATE,
  METHOD_MANAGEMENT_SOFTWARE_VERSION_DELETE,
  METHOD_VMWAREMAPPER_LIST,
  METHOD_VMWARE_COMBINE_KEY_CREATE,
  METHOD_VMWARE_COMBINE_KEY_DELETE,
  METHOD_CPLD_MAPPING_KEY_CREATE,
  METHOD_CPLD_MAPPING_KEY_DETAILS,
  METHOD_CPLD_MAPPING_KEY_UPDATE,
  METHOD_CPLD_MAPPING_KEY_DELETE,
  METHOD_CPU_GEN_MAPPING_KEY_CREATE,
  METHOD_CPU_GEN_MAPPING_KEY_DETAILS,
  METHOD_CPU_GEN_MAPPING_KEY_UPDATE,
  METHOD_CPU_GEN_MAPPING_KEY_DELETE,
  METHOD_DRIVE_MAPPING_KEY_CREATE,
  METHOD_DRIVE_MAPPING_KEY_DETAILS,
  METHOD_DRIVE_MAPPING_KEY_UPDATE,
  METHOD_DRIVE_MAPPING_KEY_DELETE,
  METHOD_FC_SWITCH_MAPPING_KEY_CREATE,
  METHOD_FC_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE,
  METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE,
  METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE,
  METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_FC_SWITCH_MAPPING_KEY_DELETE,
  METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE,
  METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE,
  METHOD_GPU_MAPPING_KEY_CREATE,
  METHOD_GPU_MAPPING_KEY_DETAILS,
  METHOD_GPU_MAPPING_KEY_DELETE,
  METHOD_FIRMWARE_BY_SWITCH,
  METHOD_PMEM_MAPPING_KEY_CREATE,
  METHOD_PMEM_MAPPING_KEY_DETAILS,
  METHOD_PMEM_MAPPING_KEY_DELETE,
  METHOD_HBA_MAPPING_KEY_CREATE,
  METHOD_HBA_MAPPING_KEY_DETAILS,
  METHOD_HBA_MAPPING_KEY_UPDATE,
  METHOD_HBA_MAPPING_KEY_DELETE,
  METHOD_CONTROLLER_MAPPING_KEY_CREATE,
  METHOD_CONTROLLER_MAPPING_KEY_DETAILS,
  METHOD_CONTROLLER_MAPPING_KEY_UPDATE,
  METHOD_CONTROLLER_MAPPING_KEY_DELETE,
  METHOD_NIC_MAPPING_KEY_CREATE,
  METHOD_NIC_MAPPING_KEY_DETAILS,
  METHOD_NIC_MAPPING_KEY_DELETE,
  METHOD_BIOS_MAPPING_KEY_CREATE,
  METHOD_BIOS_MAPPING_KEY_DETAILS,
  METHOD_BIOS_MAPPING_KEY_DELETE,
  METHOD_EXTRA_MAPPING_KEY_CREATE,
  METHOD_EXTRA_MAPPING_KEY_DETAILS,
  METHOD_EXTRA_MAPPING_KEY_DELETE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE, 
  METHOD_OS_MAPPING_KEY_DELETE,
  METHOD_OS_MAPPING_KEY_DETAILS,
  METHOD_OS_MAPPING_KEY_CREATE
} from "constants/admin/masters/vmware";


class vmwareService {
  masters = [
    { id: 1, name: 'VMware Combine Key' },
    { id: 5, name: 'CPU Generation', masterSlug: 'cpu_generation' },
    { id: 17, name: 'BIOS/BMC' },
    { id: 4, name: 'VMware CPLD', masterSlug: 'cpld' },
    { id: 14, name: 'Operating System', masterSlug: 'vmware_operating_system' },
    { id: 3, name: 'Controller', masterSlug: 'controller' },
    { id: 13, name: 'NIC' , masterSlug: 'nic' },
    { id: 10, name: 'HBA' , masterSlug: 'hba'},
    { id: 9, name: 'GPU', masterSlug: 'gpu' },
    { id: 15, name: 'PMEM' , masterSlug: 'pmem'},
    { id: 6, name: 'Drive' , masterSlug: 'drive'},
    { id: 8, name: 'FC Switch' , masterSlug: 'fc_switch'},
    { id: 2, name: 'Block Storage', masterSlug: 'block_storage'},
    { id: 11, name: 'Leaf Switch', masterSlug: 'leaf_switch' },
    { id: 16, name: 'Spine Switch', masterSlug: 'spine_switch' },
    { id: 12, name: 'Management Switch' , masterSlug: 'management_switch'},
    { id: 7, name: 'VMware Extra' , masterSlug: 'extra' }
  ]
  // vmware master mapping 
  getAllInitialData = (masterId) => {
  
     const methodName=METHOD_VMWAREMAPPER_LIST.replace("{masterId}",masterId)
      return networkService
        .get(methodName)
        .then((response) => response.data);
  
    }

  // combine key creation 
  createCombinekey= (data) => {
    return networkService
      .post(METHOD_VMWARE_COMBINE_KEY_CREATE, data)
      .then((response) => response.data);
  };

  // combine key deletion 
  deleteVmwareCombineKey = (id) => {
    const deleteMethodName = METHOD_VMWARE_COMBINE_KEY_DELETE.replace("{ID}", id);
    return networkService
      .delete(deleteMethodName)
      .then((response) => response.data);
  };

   //vmware CPLD mapping creation 
   createCPLDMapping= (data) => {
    return networkService
      .post(METHOD_CPLD_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);

  };
  //  vmware CPLD edit item details 
 getCPLDKeyDetails = (ID) =>{
  let replaceName = METHOD_CPLD_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
  //  vmware CPLD mapping update 
  updateCPLDMapping= (ID,data) => {
    let replaceName = METHOD_CPLD_MAPPING_KEY_UPDATE.replace("{ID}", ID);
    return networkService
      .post(replaceName, data)
      .then((response) => response.data);

  };

  //  vmware CPLD mapping  deletion 
  deleteCPLDMapping = (id) => {
    const deleteMethodName = METHOD_CPLD_MAPPING_KEY_DELETE.replace("{ID}", id);
    return networkService
      .delete(deleteMethodName)
      .then((response) => response.data);
  };


// vmware CPU generation mapping creation
createCPUGenerationMapping=(data) => {
  console.log("createCPUGenerationMapping is called", data);
  return networkService
    .post(METHOD_CPU_GEN_MAPPING_KEY_CREATE, data)
    .then((response) => response.data);

};
//  vmware CPU generation edit item details 
getCPUGenKeyDetails = (ID) =>{
  let replaceName = METHOD_CPU_GEN_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
//  vmware CPU generation update 
updateCPUGenMapping= (ID,data) => {
  let replaceName = METHOD_CPU_GEN_MAPPING_KEY_UPDATE.replace("{ID}", ID);
  console.log({replaceName})
  return networkService
    .post(replaceName, data)
    .then((response) => response.data);

};
//  vmware CPU generation deletion 
deleteCPUGenMapping = (id) => {
  const deleteMethodName = METHOD_CPU_GEN_MAPPING_KEY_DELETE.replace("{ID}", id);
  return networkService
    .delete(deleteMethodName)
    .then((response) => response.data);
};
  
// vmware drive mapping creation
createDriveMapping=(data) => {
  console.log("createDriveMapping funcion is called", data);
  return networkService
    .post(METHOD_DRIVE_MAPPING_KEY_CREATE, data)
    .then((response) => response.data);

};
//  get vmware drive edit item details 
getDriveKeyDetails = (ID) =>{
  let replaceName = METHOD_DRIVE_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
 //  vmware drive update 
updateDriveMapping= (ID,data) => {
  let replaceName = METHOD_DRIVE_MAPPING_KEY_UPDATE.replace("{ID}", ID);
  return networkService
    .post(replaceName, data)
    .then((response) => response.data);

};
//  vmware drive deletion 
deleteDriveMapping = (id) => {
  const deleteMethodName = METHOD_DRIVE_MAPPING_KEY_DELETE.replace("{ID}", id);
  return networkService
    .delete(deleteMethodName)
    .then((response) => response.data);
};

  // get firmware corresponding to selected switch
  getFirmwareBySwitch = (productId, switchId) => {
    const url = METHOD_FIRMWARE_BY_SWITCH?.replace('{product_id}', productId)
      .replace('{switch_id}', switchId);
    return networkService
      .get(url)
      .then(response => response?.data);
  }

  // vmware FC Switch
  createFcSwitchMapping = (data) => {
    return networkService
      .post(METHOD_FC_SWITCH_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);
  };

  getFcSwitchMappingDetails = (id) => {
    const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.get(mappingDetailsUrl)
      .then((response) => response.data)
  };

  updateFcSwitchMappingById= (id, updatedData) => {
    const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.post(mappingDetailsUrl, updatedData)
      .then((response) => response.data)
  };

  deleteFcSwitchMappingById= (id) => {
    const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
    return networkService.delete(mappingDetailsUrl)
      .then((response) => response.data)
  };

  // vmware leaf Switch
  createLeafSwitchMapping = (data) => {
    return networkService
      .post(METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);
  };

  //  vmware leaf switch
  getLeafSwitchMappingDetails = (id) => {
    const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.get(mappingDetailsUrl)
      .then((response) => response.data)
  };

  updateLeafSwitchMappingById= (id, updatedData) => {
    const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.post(mappingDetailsUrl, updatedData)
      .then((response) => response.data)
  };

  deleteLeafSwitchMappingById= (id) => {
    const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
    return networkService.delete(mappingDetailsUrl)
      .then((response) => response.data)
  };


  // vmware spine Switch
  createSpineSwitchMapping = (data) => {
    return networkService
      .post(METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);
  };

  getSpineSwitchMappingDetails = (id) => {
    const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.get(mappingDetailsUrl)
      .then((response) => response.data)
  };

  updateSpineSwitchMappingById= (id, updatedData) => {
    const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.post(mappingDetailsUrl, updatedData)
      .then((response) => response.data)
  };

  deleteSpineSwitchMappingById= (id) => {
    const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
    return networkService.delete(mappingDetailsUrl)
      .then((response) => response.data)
  };

  
  // vmware management Switch
  createManagementSwitchMapping = (data) => {
    return networkService
      .post(METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);
  };

  getManagementSwitchMappingDetails = (id) => {
    const mappingDetailsUrl = METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.get(mappingDetailsUrl)
      .then((response) => response.data)
  };

  updateManagementSwitchMappingById= (id, updatedData) => {
    const mappingDetailsUrl = METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.post(mappingDetailsUrl, updatedData)
      .then((response) => response.data)
  };

  deleteManagementSwitchMappingById= (id) => {
    const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
    return networkService.delete(mappingDetailsUrl)
      .then((response) => response.data)
  };

  // vmware gpu

  createGpuMapping = (data) => {
    return networkService
      .post(METHOD_GPU_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);
  };

  getGpuMappingDetails = (id) => {
    const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.get(mappingDetailsUrl)
      .then((response) => response.data)
  };

  updateGpuMappingById= (id, updatedData) => {
    const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DETAILS.replace("{ID}", id)
    return networkService.post(mappingDetailsUrl, updatedData)
      .then((response) => response.data)
  };

  deleteGpuMappingById= (id) => {
    const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DELETE.replace("{ID}", id)
    return networkService.delete(mappingDetailsUrl)
      .then((response) => response.data)
  };


    // vmware pmem

    createPmemMapping = (data) => {
      return networkService
        .post(METHOD_PMEM_MAPPING_KEY_CREATE, data)
        .then((response) => response.data);
    };
  
    getPmemMappingDetails = (id) => {
      const mappingDetailsUrl = METHOD_PMEM_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.get(mappingDetailsUrl)
        .then((response) => response.data)
    };
  
    updatePmemMappingById= (id, updatedData) => {
      const mappingDetailsUrl = METHOD_PMEM_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.post(mappingDetailsUrl, updatedData)
        .then((response) => response.data)
    };
  
    deletePmemMappingById= (id) => {
      const mappingDetailsUrl = METHOD_PMEM_MAPPING_KEY_DELETE.replace("{ID}", id)
      return networkService.delete(mappingDetailsUrl)
        .then((response) => response.data)
    };

    getAllVmware = () => {

    return new Promise((resolve, reject) => {
      resolve({
        total: 16,
        items: this.masters
      })
    })


    
  };

//  vmware hba mapping creation
createHbaMapping=(data) => {
  console.log("createHbaMapping function is called", data);
  return networkService
    .post(METHOD_HBA_MAPPING_KEY_CREATE, data)
    .then((response) => response.data);
};
//  get vmware hba edit item details 
getHbaKeyDetails = (ID) =>{
  let replaceName = METHOD_HBA_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
 //  vmware hba update 
updateHbaMapping= (ID,data) => {
  let replaceName = METHOD_HBA_MAPPING_KEY_UPDATE.replace("{ID}", ID);
  return networkService
    .post(replaceName, data)
    .then((response) => response.data);

};
//  vmware hba deletion 
deleteHbaMapping = (id) => {
  const deleteMethodName = METHOD_HBA_MAPPING_KEY_DELETE.replace("{ID}", id);
  return networkService
    .delete(deleteMethodName)
    .then((response) => response.data);
};

//  vmware controller mapping creation
createControllerMapping=(data) => {
  console.log("createControllerMapping function is called", data);
  return networkService
    .post(METHOD_CONTROLLER_MAPPING_KEY_CREATE, data)
    .then((response) => response.data);
};
//  get vmware controller edit item details 
getControllerKeyDetails = (ID) =>{
  let replaceName = METHOD_CONTROLLER_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
 //  vmware controller update 
updateControllerMapping= (ID,data) => {
  let replaceName = METHOD_CONTROLLER_MAPPING_KEY_UPDATE.replace("{ID}", ID);
  return networkService
    .post(replaceName, data)
    .then((response) => response.data);

};
//  vmware controller deletion 
deleteControllerMapping = (id) => {
  const deleteMethodName = METHOD_CONTROLLER_MAPPING_KEY_DELETE.replace("{ID}", id);
  return networkService
    .delete(deleteMethodName)
    .then((response) => response.data);
};
//** vmware block storage methods**/ 
//  vmware block storage mapping creation
createBlockStorageMapping=(data) => {
  console.log("createBlockStorageMapping function is called", data);
  return networkService
    .post(METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE, data)
    .then((response) => response.data);
};
//  get vmware block storage edit item details 
getBlockStorageKeyDetails = (ID) =>{
  let replaceName = METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS.replace("{ID}", ID)
  return networkService.get(replaceName)
  .then((response)=> response.data)
}
 //  vmware block storage update 
updateBlockStorageMapping= (ID,data) => {
  let replaceName = METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE.replace("{ID}", ID);
  return networkService
    .post(replaceName, data)
    .then((response) => response.data);

};
//  vmware block storage deletion 
deleteBlockStorageMapping = (id) => {
  const deleteMethodName = METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE.replace("{ID}", id);
  return networkService
    .delete(deleteMethodName)
    .then((response) => response.data);
};
// nic
createNicMapping = (data) => {
  return networkService
  .post(METHOD_NIC_MAPPING_KEY_CREATE, data)
  .then(response => response.data);
};

getNicMappingDetails = (id) => {
  const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.get(mappingDetailsUrl)
    .then((response) => response.data);
};

updateNicMappingById = (id, updatedData) => {
  const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.post(mappingDetailsUrl, updatedData)
    .then((response) => response.data)
};

deleteNicMappingById = (id) => {
  const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DELETE.replace("{ID}", id)
  return networkService.delete(mappingDetailsUrl)
    .then((response) => response.data)
};

// bios/bmc
createBiosBmcMapping = (data) => {
  return networkService
  .post(METHOD_BIOS_MAPPING_KEY_CREATE, data)
  .then(response => response.data);
};

getBiosMappingDetails = (id) => {
  const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.get(mappingDetailsUrl)
    .then((response) => response.data);
};

updateBiosMappingById = (id, updatedData) => {
  const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.post(mappingDetailsUrl, updatedData)
    .then((response) => response.data)
};

deleteBiosMappingById = (id) => {
  const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DELETE.replace("{ID}", id)
  return networkService.delete(mappingDetailsUrl)
    .then((response) => response.data)
};

// extra
createExtraMapping = (data) => {
  return networkService
  .post(METHOD_EXTRA_MAPPING_KEY_CREATE, data)
  .then(response => response.data);
};

getExtraMappingDetails = (id) => {
  const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.get(mappingDetailsUrl)
    .then((response) => response.data);
};

updateExtraMappingById = (id, updatedData) => {
  const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.post(mappingDetailsUrl, updatedData)
    .then((response) => response.data)
};

deleteExtraMappingById = (id) => {
  const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_DELETE.replace("{ID}", id)
  return networkService.delete(mappingDetailsUrl)
    .then((response) => response.data)
};

// os
createOsMapping = (data) => {
  return networkService
  .post(METHOD_OS_MAPPING_KEY_CREATE, data)
  .then(response => response.data);
};

getOsMappingDetails = (id) => {
  const mappingDetailsUrl = METHOD_OS_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.get(mappingDetailsUrl)
    .then((response) => response.data);
};

updateOsMappingById = (id, updatedData) => {
  const mappingDetailsUrl = METHOD_OS_MAPPING_KEY_DETAILS.replace("{ID}", id)
  return networkService.post(mappingDetailsUrl, updatedData)
    .then((response) => response.data)
};

deleteOsMappingById = (id) => {
  const mappingDetailsUrl = METHOD_OS_MAPPING_KEY_DELETE.replace("{ID}", id)
  return networkService.delete(mappingDetailsUrl)
    .then((response) => response.data)
};

  //VMWARE SOLUTION TYPE METHODS
  getAllVmwareSolutionType = (data) => {
    return networkService
      .post(METHOD_VMWARE_SOLUTION_TYPE_LIST, data)
      .then((response) => response.data);
  };
  getVmwareSolutionTypeDetail = (id) => {
    const updatedMethodName = METHOD_VMWARE_SOLUTION_TYPE_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVmwareSolutionType = (data) => {
    return networkService
      .post(METHOD_VMWARE_SOLUTION_TYPE_CREATE, data)
      .then((response) => response.data);
  };
  updateVmwareSolutionType = (data, id) => {
    const updatedMethodName = METHOD_VMWARE_SOLUTION_TYPE_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVmwareSolutionType = (id,is_delete=false) => {
    const updatedMethodName = METHOD_VMWARE_SOLUTION_TYPE_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };

  //UCP Release Version
  getAllUCPReleaseVersion = (data) => {
    return networkService
      .post(METHOD_UCP_RELEASE_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getDetailUCPReleaseVersion = (id) => {
    const updatedMethodName = METHOD_UCP_RELEASE_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createUCPReleaseVersion = (data) => {
    return networkService
      .post(METHOD_UCP_RELEASE_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateUCPReleaseVersion = (data, id) => {
    const updatedMethodName = METHOD_UCP_RELEASE_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteUCPReleaseVersion = (id,is_delete=false) => {
    const updatedMethodName = METHOD_UCP_RELEASE_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };

  //VMWARE VCF Version
  getAllVmwareVcfVersion = (data) => {
    return networkService
      .post(METHOD_VMWARE_VCF_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getDetailVmwareVcfVersion = (id) => {
    const updatedMethodName = METHOD_VMWARE_VCF_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVmwareVcfVersion = (data) => {
    return networkService
      .post(METHOD_VMWARE_VCF_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateVmwareVcfVersion = (data, id) => {
    const updatedMethodName = METHOD_VMWARE_VCF_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVmwareVcfVersion = (id,is_delete=false) => {
    const updatedMethodName = METHOD_VMWARE_VCF_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };

  //Management Software Version
  getAllVDIManagementSoftwareVersion = (data) => {
    return networkService
      .post(METHOD_MANAGEMENT_SOFTWARE_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getDetailVDIManagementSoftwareVersion = (id) => {
    const updatedMethodName = METHOD_MANAGEMENT_SOFTWARE_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVDIManagementSoftwareVersion = (data) => {
    return networkService
      .post(METHOD_MANAGEMENT_SOFTWARE_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateVDIManagementSoftwareVersion = (data, id) => {
    const updatedMethodName = METHOD_MANAGEMENT_SOFTWARE_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVDIManagementSoftwareVersion = (id,is_delete=false) => {
    const updatedMethodName = METHOD_MANAGEMENT_SOFTWARE_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };

}
export default vmwareService;
